import { ref, watch, computed } from '@vue/composition-api'
import { useToast } from "vue-toastification/composition";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import i18n from "@/libs/i18n";
import store from "@/store";
import axios from '@axios'

export default function productsListQuery() {
    const toast = useToast()
    const refProductListTable = ref(null)
    const perPage = ref(10)
    const totalProducts = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const familyOptions = ref([])
    const familyFilter = ref(null)
    const taxOptions = ref([])
    const taxFilter = ref(null)
    const groupOptions = ref([])

    const tableColumns = ref([
        { key: 'name', label: i18n.t('Name'), sortable: true },
        { key: 'stock', label: 'Stock disponible' },
        { key: 'family', label: i18n.t('Family'), sortable: true },
        { key: groupOptions.value.length>1 ? 'group' : '', label: i18n.t('Group') },
        { key: 'amount', label: i18n.t('Amount'), sortable: true},
        { key: 'stock', label: i18n.t('Stock'), sortable: true },
        { key: 'actions', label: i18n.t('Actions') }
    ])

    const dataMeta = computed(() => {
        const localItemsCount = refProductListTable.value ? refProductListTable.value.localItems.length: 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalProducts.value,
        }
    });

    const refetchData = function() {
        refProductListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, familyFilter, taxFilter], () => {
        refetchData()
    })

    const fetchProducts = function(ctx, callback) {
        store.dispatch('products/fetchProducts', {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            family: familyFilter.value,
            tax: taxFilter.value
        })
        .then(response => {
            const { products, total, families, taxes } = response.data
            callback(products)
            totalProducts.value = total
            familyOptions.value = families
            taxOptions.value = taxes
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching products list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    const fetchGroups = () => {
        axios.get('groups').then(response => {
            groupOptions.value=response.data.groups

            tableColumns.value = [
                { key: 'name', label: i18n.t('Name'), sortable: true },
                { key: 'stock', label: 'Stock disponible' },
                { key: 'family', label: i18n.t('Family'), sortable: true },
                { key: groupOptions.value.length>1 ? 'group' : '', label: i18n.t('Group') },
                { key: 'amount', label: i18n.t('Amount'), sortable: true},
                { key: 'stock', label: i18n.t('Stock'), sortable: true },
                { key: 'actions', label: i18n.t('Actions') }
            ]
        })
    }

    fetchGroups()

    return {
        fetchProducts,
        tableColumns,
        perPage,
        currentPage,
        totalProducts,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refProductListTable,
        refetchData,
        familyOptions,
        familyFilter,
        taxOptions,
        taxFilter,
        fetchGroups,
        groupOptions
    }
}
